<template>
  <div>
    <div class="banner">
      <span>{{$t('home.s4_1')}}</span>
    </div>
    <div class="section-wrap ">


          <div class="tech-table-w pc">
            <div class="tech-table table">
              <div class="tech-cell table-cell tech-img1 icon-tri icon-tri-right" >
              </div>
              <div class="tech-cell table-cell tech-info">
                <p class="tech-title c-333">{{$t("program.banner[0].t1")}}</p>
                <div class="tech-text c-666">{{$t("program.banner[0].t3")}}</div>
                <a @click="routerSkip('/program/list',1)">{{$t("common.more")}}</a>
              </div>
            </div>
            <div class="tech-table table">

              <div class="tech-cell table-cell tech-info">
                <p class="tech-title c-333">{{$t("program.banner[2].t1")}}</p>
                <div class="tech-text c-666">{{$t("program.banner[2].t3")}}</div>
                <a @click="routerSkip('/program/list',3)">{{$t("common.more")}}</a>
              </div>
              <div class="tech-cell table-cell tech-img2 icon-tri icon-tri-left" >
              </div>
            </div>
            <div class="tech-table table">
              <div class="tech-cell table-cell tech-img3 icon-tri icon-tri-right" >
              </div>
              <div class="tech-cell table-cell tech-info">
                <p class="tech-title c-333">{{$t("program.banner[1].t1")}}</p>
                <div class="tech-text c-666">{{$t("program.banner[1].t3")}}</div>
                <a @click="routerSkip('/program/list',2)">{{$t("common.more")}}</a>
              </div>
            </div>
            
            <div class="tech-table table">
              <div class="tech-cell table-cell tech-info">
                <p class="tech-title c-333">{{$t("program.banner[3].t1")}}</p>
                <div class="tech-text c-666">{{$t("program.banner[3].t3")}}</div>
                <a @click="routerSkip('/program/list',4)">{{$t("common.more")}}</a>
              </div>
              <div class="tech-cell table-cell tech-img4 icon-tri icon-tri-left" >
              </div>
            </div>
          </div>

      <div class="tech-table-w mobile">
        <div class="tech-table table">
          <div class="tech-cell table-cell tech-img1 icon-tri icon-tri-bottom" >
          </div>
          <div class="tech-cell table-cell tech-info">
            <p class="tech-title c-333">{{$t("program.banner[0].t1")}}</p>
            <div class="tech-text c-666">{{$t("program.banner[0].t3")}}</div>
            <a @click="routerSkip('/program/list',1)">{{$t("common.more")}}</a>
          </div>
        </div>
        <div class="tech-table table">
          <div class="tech-cell table-cell tech-img2 icon-tri icon-tri-bottom" >
          </div>
          <div class="tech-cell table-cell tech-info">
            <p class="tech-title c-333">{{$t("program.banner[2].t1")}}</p>
            <div class="tech-text c-666">{{$t("program.banner[2].t3")}}</div>
            <a @click="routerSkip('/program/list',3)">{{$t("common.more")}}</a>
          </div>

        </div>
        <div class="tech-table table">
          <div class="tech-cell table-cell tech-img3 icon-tri icon-tri-bottom" >
          </div>
          <div class="tech-cell table-cell tech-info">
            <p class="tech-title c-333">{{$t("program.banner[1].t1")}}</p>
            <div class="tech-text c-666">{{$t("program.banner[1].t3")}}</div>
            <a @click="routerSkip('/program/list',2)">{{$t("common.more")}}</a>
          </div>
        </div>
        <div class="tech-table table">
          <div class="tech-cell table-cell tech-img4 icon-tri icon-tri-bottom" >
          </div>
          <div class="tech-cell table-cell tech-info">
            <p class="tech-title c-333">{{$t("program.banner[3].t1")}}</p>
            <div class="tech-text c-666">{{$t("program.banner[3].t3")}}</div>
            <a @click="routerSkip('/program/list',4)">{{$t("common.more")}}</a>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
  import { mockAllList } from '@api/mockapi'
  import { mapMutations,mapActions } from 'vuex'


  export default {
    name: 'program',
    data () {
      return {


      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:280px;background :url("~@/assets/images/program/banner.jpg") no-repeat center/auto 100%;}
  .tab-nav>div{width:50%;}
    .tab-content{margin-bottom: 1.45rem;}
      .text1{font-size:.16rem;color:#666666;width:6.55rem;margin:0 auto;line-height:.32rem;padding:.43rem 0 .6rem;}

  .video{height:4.4rem;width:100%;display: block; }
  .video{background: url("~@/assets/images/tech/video.png") no-repeat center/cover;border-radius .05rem;}
    .tech-table-w{padding-bottom 1.2rem;padding-top:.4rem;}
    .tech-table{width:100%;background :#f8f8f8;min-height:4.38rem;background #fff;}
      .tech-cell{width:50%;vertical-align middle;padding:0.3rem .38rem;position relative;
      a{color:#999;font-size:.14rem;padding:.1rem .36rem .1rem .17rem;border:1px solid #e5e5e5;line-height :1;color:#999;position :relative;display inline-block;border-radius :.34rem;
        margin-top: .55rem;background :url("~@/assets/images/program/arrow1.png")no-repeat .8rem center/.16rem auto;min-width:1.1rem;tc()}
      }

.tech-title{font-size:.24rem;padding-bottom: .22rem;}
  .tech-label{font-size:.16rem;padding-bottom .25rem;}
  .tech-text{font-size:.16rem;line-height :.32rem;text-align:justify}
.tech-img1{background: url("~@/assets/images/program/img1.jpg") no-repeat center/cover;}
  .tech-img2{background: url("~@/assets/images/program/img2.jpg") no-repeat center/cover;}
  .tech-img3{background: url("~@/assets/images/program/img3.jpg") no-repeat center/cover;}
  .tech-img4{background: url("~@/assets/images/program/img4.jpg") no-repeat center/cover;}

    .tech-ul{padding-top:.2rem;}

  .icon-tri-right:after{border-right-color: #fff;}
  .icon-tri-left:after{border-left-color: #fff;}
    .tab1{background:#fff;}
  @media screen and (min-width: 769px){
    .tech-info:hover{
      .tech-title{color:$standardColor;}
      a{color:#fff;background :$standardColor url("~@/assets/images/program/arrow2.png")no-repeat .8rem center/.16rem auto;}
    }
  }
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .banner{height:3.7rem;background url("~@/assets/images/program/m-banner.jpg") no-repeat center/auto 100%;}
    .tab-content{background:#f8f8f8;margin-bottom: .95rem;}
      .tab1{background:#f8f8f8;}
    .text1{font-size:.26rem;width:86%;line-height:.56rem;padding:.55rem 0 .3rem;}
    .video{border-radius:0;}
    .tech-title{font-size:.32rem;padding-bottom: .1rem;}
    .tech-cell{padding: 0.48rem 0.3rem .64rem;width:100%;display :block;
      &.icon-tri{height:4.75rem;}
      a{margin-top:.5rem;font-size:.24rem;    padding: .13rem .52rem .13rem .17rem;background :url("~@/assets/images/program/arrow1.png")no-repeat 1.23rem center/.24rem auto;}
    }
    .tech-info{
      a{background :$standardColor url("~@/assets/images/program/arrow2.png")no-repeat 1.23rem center/.24rem auto;color:#fff;border:0;min-width: 1.65rem}
    }
    .tech-table{background:#fff;min-height :auto;margin-bottom :.25rem;}
    .tech-label{font-size:.24rem;padding-bottom .15rem;}
    .tech-text{font-size:.26rem;line-height .48rem;color:#666;}
    .tech-table-w{padding:0 .24rem;margin-top: 0.32rem; margin-bottom: .9rem;}
    .tech-img1{background: url("~@/assets/images/program/img1-m.png") no-repeat center/cover;}
    .tech-img2{background: url("~@/assets/images/program/img2-m.png") no-repeat center/cover;}
    .tech-img3{background: url("~@/assets/images/program/img3-m.png") no-repeat center/cover;}
    .tech-img4{background: url("~@/assets/images/program/img4-m.png") no-repeat center/cover;}
    .tech-ul{width:93.33%;margin:0 auto;}
    .icon-tri-bottom:after{border-bottom-color: #fff;}

  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
